import type {
  KycTierLimitItem,
  KycTierWalletCounts,
  UpdateKycTierLimitInput,
} from "@/modules/wallet/domain/repo/kyc-limits";
import type {
  ReviewFlagInput,
  SuspiciousFlagListResult,
  SuspiciousStats,
} from "@/modules/wallet/domain/repo/suspicious-flags";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export type {
  KycTierLimitItem,
  KycTierWalletCounts,
  SuspiciousFlagListResult,
  SuspiciousStats,
};
export type SuspiciousFlagItem = SuspiciousFlagListResult["data"][number];

export const complianceApi = {
  async listKycLimits(): Promise<{ data: KycTierLimitItem[] }> {
    return fetcher.get<{ data: KycTierLimitItem[] }>(
      `${config.apiUrl}/compliance/kyc-limits`,
    );
  },

  async getKycWalletCounts(): Promise<KycTierWalletCounts> {
    return fetcher.get<KycTierWalletCounts>(
      `${config.apiUrl}/compliance/kyc-limits/wallet-counts`,
    );
  },

  async updateKycLimit(
    id: string,
    body: UpdateKycTierLimitInput,
  ): Promise<{ ok: boolean }> {
    return fetcher.put<{ ok: boolean }>(
      `${config.apiUrl}/compliance/kyc-limits/${id}`,
      body,
    );
  },

  async getSuspiciousStats(): Promise<SuspiciousStats> {
    return fetcher.get<SuspiciousStats>(
      `${config.apiUrl}/compliance/suspicious/stats`,
    );
  },

  async listSuspicious(
    query: OffsetPageQueryDTO,
  ): Promise<SuspiciousFlagListResult> {
    const url = new URL(`${config.apiUrl}/compliance/suspicious`);
    url.searchParams.set("limit", String(query.limit ?? 20));
    url.searchParams.set("offset", String(query.offset ?? 0));
    if (query.sort) url.searchParams.set("sort", JSON.stringify(query.sort));
    if (query.filters)
      url.searchParams.set("filters", JSON.stringify(query.filters));
    return fetcher.get<SuspiciousFlagListResult>(url.toString());
  },

  async reviewFlag(
    id: string,
    body: ReviewFlagInput,
  ): Promise<{ ok: boolean }> {
    return fetcher.post<{ ok: boolean }>(
      `${config.apiUrl}/compliance/suspicious/${id}/review`,
      body,
    );
  },
};
